import { render, staticRenderFns } from "./SkinChipLinkAuthorWorkshop.vue?vue&type=template&id=41c4e4d6&scoped=true&"
import script from "./SkinChipLinkAuthorWorkshop.vue?vue&type=script&lang=ts&"
export * from "./SkinChipLinkAuthorWorkshop.vue?vue&type=script&lang=ts&"
import style0 from "./SkinChipLinkAuthorWorkshop.vue?vue&type=style&index=0&id=41c4e4d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c4e4d6",
  null
  
)

export default component.exports